import { useQuery } from 'react-query';
import apiService from 'services/api.service';

export default function useGetAIResult(resultId, queryOptions) {
  return useQuery(
    ['transaction.ai.result', resultId],
    () => (resultId ? apiService.get(`/transactions/result/${resultId}`) : null),
    queryOptions,
  );
}
